import { cn } from "@/common/helpers/utils";
import { CenteredLayout, CenteredLayoutVariant } from "@/components/layouts/centered-layout";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import type { ReactElement } from "react";

const CARD_ROW_COUNTS = [5, 3, 10];

const SKELETON_CARDS = CARD_ROW_COUNTS.map((rowCount, cardIndex) => ({
  id: `card-${cardIndex}`,
  rows: Array.from({ length: rowCount }, (_, rowIndex) => `card-${cardIndex}-row-${rowIndex}`),
}));

export function BranchDetailSkeleton(): ReactElement {
  return (
    <CenteredLayout variant={CenteredLayoutVariant.Wide}>
      <header className="flex flex-wrap items-start justify-between gap-4">
        <div className="flex min-w-0 items-center gap-4">
          <Skeleton className="size-12 shrink-0 rounded-lg" />
          <div className="flex flex-col gap-2">
            <Skeleton className="h-7 w-48" />
            <Skeleton className="h-4 w-32" />
          </div>
        </div>
        <div className="flex gap-2">
          <Skeleton className="h-8 w-20" />
          <Skeleton className="h-8 w-20" />
        </div>
      </header>

      <div className="mt-2 flex flex-col gap-6">
        <div className="flex gap-2">
          <Skeleton className="h-9 w-28" />
          <Skeleton className="h-9 w-28" />
          <Skeleton className="h-9 w-28" />
        </div>

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2 xl:grid-cols-3">
          {SKELETON_CARDS.map((card) => (
            <Card key={card.id} className="min-w-0 gap-2">
              <CardHeader>
                <div className="flex items-center gap-2">
                  <Skeleton className="size-3.5" />
                  <Skeleton className="h-4 w-32" />
                </div>
              </CardHeader>
              <CardContent className="flex flex-col">
                {card.rows.map((rowId, rowIndex) => (
                  <div key={rowId} className="grid grid-cols-[7.5rem_minmax(0,1fr)] items-baseline gap-x-4 py-1.5">
                    <Skeleton className="h-4 w-20" />
                    <Skeleton className={cn("h-4", rowIndex % 2 === 0 ? "w-40" : "w-28")} />
                  </div>
                ))}
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </CenteredLayout>
  );
}
